
export default function CTA() {
  return (
    <section id="security" className="relative py-44 px-32 overflow-hidden bg-gradient-to-b from-[#1A1F3A] via-[#0A0E27] to-[#1A1F3A]">
      {/* Radial Gradient Spotlight */}
      <div 
        className="absolute inset-0 opacity-30"
        style={{
          background: 'radial-gradient(circle at center, rgba(0,212,255,0.2) 0%, transparent 70%)'
        }}
      />

      {/* Floating Geometric Shapes */}
      <div className="absolute top-20 left-20 w-32 h-32 border border-white/5 rounded-full animate-pulse" />
      <div className="absolute bottom-32 right-32 w-24 h-24 border border-white/5 rotate-45" style={{ animationDelay: '1s' }} />
      <div className="absolute top-1/2 left-1/4 w-16 h-16 border border-white/5 rounded-full animate-pulse" style={{ animationDelay: '0.5s' }} />
      <div className="absolute bottom-1/4 right-1/4 w-20 h-20 border border-white/5 rotate-12 animate-pulse" style={{ animationDelay: '1.5s' }} />

      <div className="relative z-10 text-center max-w-4xl mx-auto">
        <h2 className="text-6xl font-bold text-white mb-7 leading-tight">
          Ready to Secure Your Connection?
        </h2>
        <p className="text-xl text-[#B8C5D6] mb-14">
          Join thousands protecting their digital life
        </p>
        
        <button className="group inline-flex items-center justify-center gap-4 px-16 h-16 rounded-xl bg-gradient-to-r from-[#00D4FF] to-[#0099CC] text-white text-lg font-bold transition-all duration-300 hover:shadow-2xl hover:shadow-[#00D4FF]/50 animate-pulse hover:animate-none hover:-translate-y-1 whitespace-nowrap cursor-pointer">
          <i className="ri-download-line text-2xl"></i>
          Download Now
        </button>

        <p className="text-sm text-[#8B95A8] mt-8">
          Available for macOS &amp; iOS
        </p>
      </div>
    </section>
  );
}
